import styles from './PairItemContainer.module.css';
import classNames from 'classnames';

const PairItemContainer = ({
    className,
    children
}: {
    className?: string;
    children: any; // This needs refactoring so the children are not accessed via indexs
}) => {
    return (
        <div className={classNames(styles.PairItemContainer, className)}>
            <div className={styles.leftChild}>{children[0]}</div>
            <div className={styles.rightChild}>{children[1]}</div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default PairItemContainer;
